import script from "./ServiceStatusItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./ServiceStatusItem.vue?vue&type=script&setup=true&lang=ts"

import "./ServiceStatusItem.vue?vue&type=style&index=0&id=4189ab82&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4189ab82"]])

export default __exports__